import type { SxProps, Theme } from '@mui/material/styles';

export const resourcesPanelStyles: Record<string, SxProps<Theme>> = {
  paper: (theme) => ({
    width: { xs: '100%', md: 460 },
    maxWidth: '100%',
    maxHeight: { xs: '88vh', md: '100%' },
    borderTopLeftRadius: { xs: '16px', md: 0 },
    borderTopRightRadius: { xs: '16px', md: 0 },
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.default,
  }),
  header: (theme) => ({
    position: 'sticky',
    top: 0,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
  }),
  headerText: { display: 'flex', flexDirection: 'column', gap: 0.75, minWidth: 0 },
  title: (theme) => ({
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: '1.0625rem',
    lineHeight: 1.3,
    color: theme.palette.text.primary,
  }),
  subtitle: (theme) => ({
    fontFamily: theme.typography.fontFamily,
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  }),
  close: (theme) => ({
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(-0.5),
    marginRight: theme.spacing(-0.5),
  }),
  list: {
    overflowY: 'auto',
    paddingInline: 3,
  },
  item: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    paddingBlock: theme.spacing(2.5),
  }),
  itemTitle: (theme) => ({
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: '0.9375rem',
    lineHeight: 1.35,
    color: theme.palette.text.primary,
  }),
  itemYear: (theme) => ({
    fontFamily: theme.typography.fontFamily,
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
  }),
  itemDesc: (theme) => ({
    fontFamily: theme.typography.fontFamily,
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
  }),
  learnMore: (theme) => ({
    fontFamily: theme.typography.linkStrong.fontFamily,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: '0.875rem',
    color: theme.palette.primary.main,
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    width: 'fit-content',
    marginTop: theme.spacing(0.5),
  }),
};
